import { inject, Injectable } from '@angular/core';
import { BffApiBusyService } from '@raxapp/booker-backend-apis/bff-api-busy.service';
import { RaxBFF } from '@raxapp/booker-backend-apis/bff-api-clients/booker.planner.bff.api';
import { BffApiService } from '@raxapp/booker-backend-apis/bff-api.service';
import { finalize, Observable, tap } from 'rxjs';

@Injectable()
export class ShellDataService {
    private readonly bffApiService = inject(BffApiService);
    private readonly bffApiBusyService = inject(BffApiBusyService);

    public initShellView(): Observable<RaxBFF.ShellView> {
        return this.bffApiService.bffClient.shell_GetShellView({ forMobile: true }).pipe(
            tap({ subscribe: () => this.bffApiBusyService.add({ id: this.initShellView.name }) }),
            finalize(() => this.bffApiBusyService.remove(this.initShellView.name)),
        );
    }
}
